import { type PropsWithChildren } from 'react';

type InfoCardHeaderProps = PropsWithChildren<{
  expandable?: boolean;
  onClick?: () => void;
}>;

export const InfoCardHeader = ({
  expandable,
  children,
  onClick,
}: InfoCardHeaderProps) => {
  if (expandable) {
    return (
      <button
        type="button"
        className="flex w-full items-center gap-3 text-left"
        onClick={onClick}
      >
        {children}
      </button>
    );
  }

  return <div className="flex w-full items-center gap-3">{children}</div>;
};
